import React, { Component, Fragment } from 'react';
import './BackgroundPolygons.module.scss';

class BackgroundPolygons extends Component {

    render() {
        return (
            <Fragment>
                <div styleName='polygon1'></div>
                <div styleName='polygon2'></div>
            </Fragment>
        );  
    }
}

export default BackgroundPolygons;


// WEBPACK FOOTER //
// ./resources/assets/components/UI/BackgroundPolygons/BackgroundPolygons.jsx